import BaseOverlay, { BaseOverlayProps } from './BaseOverlay';
import React from 'react';

export interface FullscreenOverlayProps extends BaseOverlayProps {}

const FullscreenOverlay = (props) => (
  <BaseOverlay {...props} fullscreen />
);

export default FullscreenOverlay;
